import { FC, MouseEventHandler, MouseEvent } from 'react';
import { connect } from 'react-redux';
import classNames from 'classnames';
import { useIntl, defineMessages } from 'dibs-react-intl';
import { trackEvent } from 'dibs-tracking';
import { Link } from 'dibs-elements/exports/Link';
import CartIcon from 'dibs-icons/exports/Cart';
import ShoppingBagIcon from 'dibs-icons/exports/ShoppingBag';

import styles from './CartNav-style.scss';

const MAX_CART_COUNT_DISPLAY = 9;

function handleOnClick(event: MouseEvent): void {
    trackEvent(
        {
            category: 'navigation',
            action: 'header navigation click',
            label: 'cart|cart header link',
        },
        event
    );
}

type ReduxStoreType = {
    header: {
        isNavigationRefreshVariant: boolean;
    };
};

type CartNavDropdownTriggerProps = {
    count: number;
    handleMouseEnter?: MouseEventHandler;
    isNavigationRefreshVariant: boolean;
};

const CartNavCount: FC<{ count: number }> = ({ count }) => (
    <div className={styles.countWrapper}>
        <span className={styles.count}>
            {count}
            {count === MAX_CART_COUNT_DISPLAY ? <sup>+</sup> : null}
        </span>
    </div>
);
const messages = defineMessages({
    label: { id: 'dbl.Header.CartNavDropdownTrigger.label', defaultMessage: 'Cart' },
});
const CartNavDropdownTrigger: FC<CartNavDropdownTriggerProps> = ({
    count = 0,
    handleMouseEnter = () => {},
    isNavigationRefreshVariant,
}) => {
    count = Math.min(count, MAX_CART_COUNT_DISPLAY);
    const intl = useIntl();
    const wrapperClassName = classNames(styles.iconWrapper, {
        [styles.navigationRefreshWrapper]: isNavigationRefreshVariant,
    });

    return (
        <div
            data-tn="cart-nav-dropdown-trigger"
            className={wrapperClassName}
            onMouseEnter={handleMouseEnter}
        >
            <Link
                className={styles.icon}
                href="/my/cart/"
                ariaLabel={intl.formatMessage(messages.label)}
                onClick={handleOnClick}
            >
                {count ? <CartNavCount count={count} /> : null}
                {isNavigationRefreshVariant ? <ShoppingBagIcon /> : <CartIcon />}
            </Link>
        </div>
    );
};

const mapStateToProps = ({
    header,
}: ReduxStoreType): {
    isNavigationRefreshVariant: boolean;
} => {
    const { isNavigationRefreshVariant } = header;
    return {
        isNavigationRefreshVariant,
    };
};

export default connect(mapStateToProps)(CartNavDropdownTrigger);
